import { CommonPurchaseTaxes } from '..'

export const CanadaPurchaseTaxes = {
  ...CommonPurchaseTaxes,
} as const
